import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Button, BoxWrapper } from 'components/Base';
import ChargesTable from './ChargesTable';
import Store from 'store/store';
import { combineCharges } from '../utils';
import Charts from 'components/Charts';

const { connect, selectors } = Store;

const useStyles = makeStyles({
  box: {
    height: '100%',
    boxShadow: 'none'
  }
});

interface ChargesWrapperProps {
  existingPolicyCharges: any;
  recommendedPoliciesCharges: any;
  existingOnly?: boolean;
}

const ChargesWrapper = ({
  existingPolicyCharges,
  recommendedPoliciesCharges,
  existingOnly = false
}: ChargesWrapperProps) => {
  const [displayTable, setDisplayTable] = useState(true);
  const classes = useStyles();
  const allCharges = combineCharges(
    existingPolicyCharges,
    recommendedPoliciesCharges
  );

  return (
    <BoxWrapper
      title="Total annual costs & charges"
      headerChildren={
        <div
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}
        >
          <Button
            onClick={() => {
              setDisplayTable(!displayTable);
            }}
          >
            {displayTable ? 'Chart View' : 'Table View'}
          </Button>
        </div>
      }
      className={classes.box}
    >
      {displayTable ? (
        <ChargesTable existingOnly={existingOnly} />
      ) : (
        <Charts.ExistingPolicyAnalysis.PolicyCharges
          data={existingOnly ? existingPolicyCharges : allCharges}
        />
      )}
    </BoxWrapper>
  );
};

export default connect((state: any) => ({
  existingPolicyCharges: selectors.caseSelectors.existingPoliciesCharges(state),
  recommendedPoliciesCharges:
    selectors.caseSelectors.recommendedPoliciesCharges(state)
}))(ChargesWrapper);
